// extracted by mini-css-extract-plugin
module.exports = {"iconAndTextGrouping":"BatteryChip_iconAndTextGrouping__fzBBv"};